<template>
    <div class="ImageText">
        <div class='ImageText1 szpt2' :style="{background: urlb != '' ? 'url('+require('../assets/'+urlb)+') #ffffff no-repeat center' : '#ffffff'}">
            <div class='szrl3_content'>
                <div>{{title}}</div>
                <div>{{content}}</div>
                <img :src="require('../assets/'+url)" />
                <div class='sub' :style='{width: width+"px"}' v-if='text != ""' @click='visible = true'>{{text}}</div>
            </div>
        </div>

        <Loding :visible.sync='visible'></Loding>
    </div>
</template>

<script>
export default {
    name: 'ImageText',
    props: {
        // 按钮宽度
        width: {
            type: String,
            default: '205'
        },
        // 按钮文字
        text: {
            type: String,
            default: '获取解决方案'
        },
        // 图片地址
        url: {
            type: String,
            default: ''
        },
        // 背景图地址
        urlb: {
            type: String,
            default: ''
        },
        // 标题
        title: {
            type: String,
            default: ''
        },
        // 标题内容
        content: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            visible: false,
        }
    },
    mounted() {

    },
    methods:{

    }
}
</script>

<style lang="scss" scoped>
    .ImageText{
        .ImageText1{
            padding-top: 70px;
            min-height: 300px;
            padding-bottom: 90px;
            background-size: 100% 100%!important;
            .szrl3_content{
                margin: 0 auto;
                >div:nth-of-type(1) {
                    font-size: 30px;
                    margin-bottom: 30px;
                    line-height: 1.1;
                    text-align: center;
                    color: #e31924;
                    font-weight: bold;
                }
                >img{
                    height: 100%;
                }
                >div:nth-of-type(2) {
                    font-size: 14px;
                    color: #333;
                    margin-bottom: 30px;
                    text-align: center;
                }
                >div:nth-of-type(3) {
                    display: block;
                    height: 46px;
                    line-height: 46px;
                    color: #ffffff;
                    font-size: 18px;
                    text-align: center;
                    background-image: linear-gradient(131deg, #e5732d 0%, #e31924 52%);
                    border-radius: 6px;
                    margin: 70px auto 0;
                    cursor: pointer;
                }
            }
        }
    }
</style>
<style scoped>
@media all and (min-width: 980px) {
    .footer2{
        display: none !important;
    }
    .footer1{
        display: block !important;
    }
    .ImageText .ImageText1 .szrl3_content > img{
        width: 75rem;

    }
    .ImageText .ImageText1 .szrl3_content{
        width: 75rem;

    }

}
@media all and (max-width: 980px) {

    .ImageText .ImageText1 .szrl3_content > img{
        width: 100% !important;
    }
    .ImageText .ImageText1 .szrl3_content{
        width: 100% !important;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/ImageText.vue